import { connect } from 'react-redux';
import { storeAudioEnabled, storeTranscriptEnabled } from '../../store/audio';
import Voiceover from './Voiceover';

const mapStateToProps = state => ({
  audioEnabled: state.audio.audioEnabled,
  transcriptEnabled: state.audio.transcriptEnabled
});

const mapDispatchToProps = dispatch => ({
  transcriptOff: () => {
    dispatch(storeTranscriptEnabled(false));
  },
  audioChange: audioEnabled => {
    dispatch(storeAudioEnabled(audioEnabled));
  },
  transcriptChange: transcriptEnabled => {
    dispatch(storeTranscriptEnabled(transcriptEnabled));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Voiceover);



// WEBPACK FOOTER //
// ../core/src/components/Voiceover/index.js